import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatMenu, MatMenuTrigger } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MatFieldComponent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { EditorChoiceDataSource, HubEvent } from '../../../../models/hub/hub.event';
import { HubPlace } from '../../../../models/hub/hub.place';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { EventTimeService } from '../../../../services/event.time.service';
import { ImageService } from '../../../../services/image.service';
import {
    AllFrontendSettingsStore,
    VisitorTripNotifyAddOrRemoveItemStore,
} from '../../../../stores/visitor.calendar.store';
import { VisitorTripSideBarComponent } from '../trip.side.bar/visitor.trip.side.bar.component';
import { VisitorTripComponent } from '../visitor.trip.component';
import { GlobalEventEmitter } from '../../../../common/services/global.event.emitter';
import { StyleModel } from '../../../../commands/hub/style.command';
import { AllFrontendSettingsCommand } from '../../../../commands/visitor/all.frontend.settings.command';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';

@Component({
    selector: 'ig-visitor-trip-place-card',
    templateUrl: './visitor.trip.place.card.component.html',
    styleUrls: ['./visitor.trip.place.card.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class VisitorTripPlaceCardComponent extends BaseComponent implements OnInit {
    @Input() public item: HubPlace;
    @Input() public itemType = 'place';
    @Input() public featuresToggle = new HubVisitorFeatureToggle();
    public iconColor = null;
    public icon = null;
    @ViewChild('menuTrigger') public menuTrigger: MatMenuTrigger;
    @ViewChild('tripTitle') public tripTitle: MatFieldComponent;
    @Output() addTo = new EventEmitter<any>();
    @Output() removeFrom = new EventEmitter<any>();
    @Output() locateOnMap = new EventEmitter<any>();
    @Output() showDetails = new EventEmitter<any>();
    public hubName: string;
    public isInAnyTrip = false;
    public detailDate: string;
    public detailTime: string;
    public totalTime: string;
    public isMultiDateEvent = false;
    public isAddingSuccess = [];
    public inTripStatus = [];
    public icons = {
        Accommodations: { icon: 'hotel', color: '#f70096' },
        'Arts & Culture': { icon: 'camera', color: '#9bd53e' },
        'Dining & Nightlife': { icon: 'restaurant', color: '#ec8f07' },
        Activities: { icon: 'local_activity', color: '#8808ec' },
        Shopping: { icon: 'local_grocery_store', color: '#0783eb' },
        'Outdoors & Fitness': { icon: 'terrain', color: '#0d8804' },
        Entertainment: { icon: 'mood', color: '#e5ce02' },
        Transportation: { icon: 'flight_takeoff', color: '#50212e' },
        Other: { icon: 'public', color: '#3d3c3c' },
    };
    public style = new StyleModel();
    public editorChoiceText = "EDITOR'S CHOICE";

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        public imageService: ImageService,
        public parent: VisitorTripSideBarComponent,
        private allFrontendSettingsStore: AllFrontendSettingsStore,
        private notifyAddOrRemoveItemStore: VisitorTripNotifyAddOrRemoveItemStore,
        private visitorTripComponent: VisitorTripComponent,
        private editorChoiceStore: EditorChoiceStore,
        private activatedRoute: ActivatedRoute
    ) {
        super({ activatedRoute });
    }

    public ngOnInit() {
        let { hubName } = this.allRouteParams;
        this.hubName = hubName;

        this.icon = this.icons[this.item.mapIcon] && this.icons[this.item.mapIcon].icon;
        this.iconColor = this.icons[this.item.mapIcon] && this.icons[this.item.mapIcon].color;

        this.notifyAddOrRemoveItemStore.notifyCommand.takeUntil(this.isDestroyed).subscribe((item) => {
            this.checkIsInAnyTrip();
        });

        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe((command: AllFrontendSettingsCommand) => {
                if (command.style) {
                    this.style = command.style as StyleModel;
                }
            });

        this.editorChoiceTextHandler();
    }

    public editorChoiceTextHandler() {
        this.editorChoiceStore.infoCommand
            .takeUntil(this.isDestroyed)
            .subscribe((editorChoice: EditorChoiceDataSource) => {
                if (!!this.item['startTime']) {
                    this.editorChoiceText = editorChoice.editorChoiceForEvent;
                } else {
                    this.editorChoiceText = editorChoice.editorChoiceForPlace;
                }
            });
    }

    public checkIsInAnyTrip() {
        this.parent.loadTripsInLocalStorage();
        if (!this.parent.trips || !this.parent.trips.length) {
            return false;
        }
        this.isInAnyTrip = false;
        this.parent.trips.forEach((trip) => {
            if (trip.attractions.any((x) => x.item.id === this.item.id)) {
                this.isInAnyTrip = true;
            }
        });
    }

    public showOnMap($event) {
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        this.locateOnMap.emit(this.item);
    }

    public viewDetails($event) {
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        this.showDetails.emit(this.item);
    }

    private processEventTime(event: HubEvent) {
        if (event.startTimeText) {
            if (!this.isMultiDateEvent) {
                this.detailDate = EventTimeService.getDateFromTimeText(event.startTimeText);
                this.detailTime = EventTimeService.getTimeFromTimeText(event.startTimeText, event.timezone);
            } else {
                this.detailDate =
                    EventTimeService.getDateFromTimeText(event.startTimeText) +
                    ' - ' +
                    EventTimeService.getDateFromTimeText(event.endTimeText);
            }
        } else {
            if (!this.isMultiDateEvent) {
                this.detailDate = EventTimeService.getDateFromTime(event.startTime);
                this.detailTime = EventTimeService.getTimeFromTime(event.startTime);
            } else {
                this.detailDate =
                    EventTimeService.getDateFromTime(event.startTime) +
                    ' - ' +
                    EventTimeService.getDateFromTime(event.startTime);
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/trip.place.card/visitor.trip.place.card.component.ts